/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import { OverlayParams } from './Types';

import { validateTitle } from './Validator';

import * as styles from './styles.module.css';

const validateParams = ({ title }: OverlayParams): void => {
  validateTitle(title);
};

const Overlay = (params: OverlayParams): JSX.Element => {
  validateParams(params);
  const { action, title } = params;
  return (
    <div className={styles.action} onClick={() => action?.()}>
      {title}
    </div>
  );
};

export default Overlay;
